import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from '../Footer'; 
import SubPageFooter from './SubPageFooter'; 

const Layout = () => {
  const location = useLocation();

  // १. Login ani Register pages check kara
  const isAuthPage = 
    location.pathname === '/TGSH/login' || 
    location.pathname === '/TGSH/register';

  // २. Sub-pages chi condition (Existing logic)
  const isSubPage = 
    location.pathname.includes('/org/') || 
    location.pathname.includes('/courses/') || 
    location.pathname.includes('/publication/') ||
    location.pathname.includes('/gallery/') ||
    location.pathname.includes('/blog/') ||
    location.pathname.includes('/feedback/') ||
    location.pathname.includes('/contact') ||
    location.pathname.includes('/partnership');

  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      
      {/* ३. Jar auth page (login/reg) nasel tarach footer dakhva */}
      {!isAuthPage && (
        isSubPage ? <SubPageFooter /> : <Footer />
      )}
    </>
  );
};

export default Layout;